import { render, staticRenderFns } from "./organisations.vue?vue&type=template&id=478f12c2"
import script from "./organisations.vue?vue&type=script&lang=ts"
export * from "./organisations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports